import React, { useState } from "react";
import PumpCalculationDetails from "./pump-calculation-details";
import PumpPressureShaft from "./pump-pressure-shaft";
import PumpIteration from "./pump-iteration";
import PumpList from "./pump-list";
import CompositePumpPlot from "./composite-pump-plot";
import PumpPlot from "./pump-plot";
import { useAppSelector } from "../../../store/hooks/StoreHooks";
import Error from "../../../assets/icons/Error";
import { Alert } from "../../../assets/icons";
const Pump: React.FC = () => {

  const [showError, setShowError] = useState<string[]>([]);

  const { FetchShaftPercentageLoad, FetchPercentageHousingLoad } = useAppSelector((state) => state.pump);

  return (
    <>
      {
        showError?.length > 0 && showError?.map(item => {
          return (
            <div className='flex p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-secondary-600 border-darkcolor-400'>
              <Alert className="mr-2" />
              <p className="text-[14px] font-bold leading-[20px] text-neutral-25">
                {item}
              </p>
            </div>
          )
        })
      }
      <div className="flex flex-col item-center w-full h-full gap-[16px]">
        <PumpCalculationDetails />
        <PumpList />
        <PumpPlot />
        <PumpPressureShaft showError={showError} setShowError={setShowError} />
        <CompositePumpPlot />
        <PumpIteration />
      </div>
    </>
  );
};

export default Pump;
